// 常量
const constan = {
  OrderStatus: [
    { label: '待支付', value: 0 },
    { label: '支付中', value: 1 },
    { label: '已支付', value: 2 },
    { label: '已确认', value: 3 },
    { label: '已发货', value: 4 },
    { label: '已收货', value: 5 },
    { label: '已完成', value: 6 },
    { label: '确认拒绝', value: 11 },
    { label: '取消订单', value: 21 },
    { label: '退款中', value: 31 },
    { label: '已退款', value: 32 },
    { label: '初始化', value: -1 },
  ],
  RefundStatus: [
    { label: '未退款', value: 0 },
    { label: '申请退款', value: 21 },
    { label: '退款失败', value: 22 },
    { label: '退款成功', value: 23 },
    { label: '待买家填写退货物流', value: 24 },
    { label: '物流进行中', value: 25 },
    { label: '物流已签收', value: 26 },
    { label: '退款退回中', value: 27 },
    { label: '取消退款', value: 28 },
    { label: '拒绝退款', value: 29 },
    { label: '拒绝退货', value: 30 },
    { label: '商家同意退货', value: 31 },
    { label: '退款成功', value: 32 },
    { label: '初始化', value: -1 },
  ],
  OrderType: [
    { label: '商品订单', value: 0 },
    { label: '积分消费订单', value: 1 },
  ],
  OverdueType: [
    { label: '未逾期', value: 0 },
    { label: '已逾期', value: 1 },
  ],
  BillStatus: [
    { label: '未支付', value: 0 },
    { label: '已支付', value: 1 },
  ],
  PayChannel: [
    { label: '微信支付', value: 1 },
    { label: '支付宝', value: 2 },
    { label: '线下支付', value: 3 },
    { label: '积分支付', value: 4 },
    { label: '绿豆抵扣', value: 5 },
    { label: '微信小程序支付', value: 6 },
    { label: '银行卡支付', value: 7 },
    { label: '混合支付', value: 8 },
  ],
  /** zy_user_points_record.status */
  PointsRecordStatus: [
    { label: '待完成', value: 0 },
    { label: '已完成', value: 1 },
    { label: '已作废', value: 2 },
  ],
  /** 积分明细 way_type（与后端 UserWealthWayType 一致） */
  FrozenPointsWayType: [
    { label: '系统充值', value: 5 },
    { label: '系统扣减', value: 6 },
    { label: '订单支付-积分抵扣', value: 72 },
    { label: '订单退款-积分退回', value: 73 },
    { label: '积分-支付未成功释放', value: 75 },
    { label: '日活跃度排行奖励', value: 78 },
    { label: '区代推荐奖励', value: 79 },
    { label: '特价商品补贴', value: 80 },
    { label: '复购补贴', value: 82 },
    { label: '活跃度兑换贡献值', value: 83 },
  ],
  /** zy_user_checkin_record.status */
  CheckinRecordStatus: [
    { label: '成功', value: 1 },
    { label: '失败/作废', value: 2 },
  ],
  /** 活跃度流水 way_type（与后端 UserActivityWayType 一致） */
  UserActivityWayType: [
    { label: '签到', value: 1 },
    { label: '激励广告', value: 2 },
    { label: '购买商品', value: 3 },
    { label: '邀请新用户注册', value: 4 },
    { label: '订单确认收货', value: 5 },
    { label: '看直播', value: 6 },
  ],
  PayStatus: [
    { label: '待支付', value: 0 },
    { label: '支付中', value: 1 },
    { label: '支付成功', value: 2 },
    { label: '支付失败', value: 3 },
  ],

  PlatformStatus: [
    { label: '无效', value: 0 },
    { label: '有效', value: 1 },
  ],
  InformationType: [
    { label: '家庭教育', value: 0 },
    { label: '传统文化', value: 1 },
    { label: '家庭娱乐', value: 2 },
    { label: '家庭经济', value: 3 },
    { label: '小区公告', value: 4 },
  ],
  // 商品活动类型
  GoodsActivityType: [
    { label: '普通活动', value: 1 },
    { label: '限时抢购', value: 0 },
    // { label: '家庭囤货', value: 2 },
  ],
  // 商品状态
  GoodsStatus: [
    { label: '已下架', value: 0 },
    { label: '已上架', value: 1 },
    { label: '上架审核中', value: 2 },
    { label: '审核失败', value: 3 },
  ],
  // 社区活动状态
  ActivityInfoStatus: [
    { label: '已下架', value: '-1' },
    { label: '报名中', value: '0' },
    { label: '已结束', value: '1' },
  ],
  // 社区活动分类
  ActivityInfoClassly: [

  ],
  // 供应商门店类型
  SupplierShopType: [
    { label: '非门店', value: false },
    { label: '门店', value: true },
  ],
  // 供应商状态
  SupplierStatus: [
    { label: '合作', value: 0 },
    { label: '未合作', value: 1 },
  ],
  // 排序方式
  SortType: [
    { label: '按标示排序', value: 0 },
    { label: '按创建时间排序', value: 1 },
  ],
  // 商品排序方式
  GoodsSortType: [
    { label: '按创建时间', value: 0 },
    { label: '按sort字段', value: 1 },
  ],
  // 评价列表排序
  CommentSortType: [
    { label: '评论时间降序', value: 0 },
    { label: '评论时间升序', value: 1 },
    { label: '评分降序', value: 2 },
    { label: '评分升序', value: 3 },
  ],
  // 评价显示状态
  CommentDisplayStatus: [
    { label: '全部', value: undefined },
    { label: '显示', value: 1 },
    { label: '隐藏', value: 0 },
  ],
  // 评价星级
  CommentScoreOptions: [
    { label: '全部', value: undefined },
    { label: '5星', value: 5 },
    { label: '4星', value: 4 },
    { label: '3星', value: 3 },
    { label: '2星', value: 2 },
    { label: '1星', value: 1 },
  ],
  // banner支持的客户端
  BannerPlatform: [
    { label: '微信小程序', value: 0 },
  ],
  // banner展示位置
  BannerChannelId: [
    { label: '首页', value: 0 },
    { label: '首页弹窗', value: 1 },
    { label: '首页-活动专栏', value: 2 },
    { label: '一县一特', value: 3 },
    { label: '薪店社区首页', value: 4 },
    { label: '待定', value: 99 },
  ],
  // banner跳转方式
  BannerJumpPage: [
    { label: '小程序内部', value: 0 },
    { label: 'H5', value: 1 },
    { label: '点击事件', value: 5 },
  ],
  // 导航栏展示位置
  NavigationChannelId: [
    { label: '首页', value: 0 },
    { label: '我的-活动中心', value: 1 },
    { label: '首页-新展示位', value: 2 },
    { label: '待定', value: 999 },
  ],
  // 导航栏扩展类型
  NavigationExpansionType: [
    { label: '臻选', value: 'curated' },
    { label: '热卖', value: 'selling' },
    { label: '闪购', value: 'sale' },
    { label: '公益', value: 'philanthropy' },
    { label: '特产', value: 'specialty' },
    { label: '直播', value: 'live' },
    { label: '年货', value: 'yeargoods' },
    { label: '薪购', value: 'xingou' },
    { label: '签到', value: 'checkin' },
  ],

  UseType: [
    { label: '尊享会员', value: 0 },
    { label: '新手福利', value: 1 },
  ],
  Status: [
    { label: '停用', value: 0 },
    { label: '启用', value: 1 },
  ],
  UserVoucherStatus: [
    { label: '未使用', value: 0 },
    { label: '已使用', value: 1 },
    { label: '已过期', value: 2 },
  ],
  // 提现状态
  WithdrawStatus: [
    { label: '申请中', value: 0 },
    { label: '申请通过', value: 1 },
    { label: '申请拒绝', value: 2 },
    { label: '提现中', value: 3 },
    { label: '提现成功', value: 4 },
    { label: '提现失败', value: 5 },
    { label: '支付系统失败', value: 6 },
    { label: '初审通过', value: 7 },
  ],
  // 药柜状态
  MedicineCabinetStatus: [
    { label: '生产中', value: 0 },
    { label: '运输中', value: 1 },
    { label: '调试中', value: 2 },
    { label: '运营中', value: 3 },
    { label: '未运营', value: 4 },
  ],
  // 店铺关闭状态
  PlatformClose: [
    { label: '否', value: false },
    { label: '是', value: true },
  ],
  // 店铺状态
  ShopStatus: [
    { label: '休息中', value: 0 },
    { label: '运营中', value: 1 },
  ],
  // 店铺审核状态
  ShopAuditStatus: [
    { label: '待提交', value: 0 },
    { label: '审核中', value: 1 },
    { label: '审核通过', value: 2 },
    { label: '审核拒绝', value: 3 },
    { label: '入网处理中', value: 4 },
  ],
  // 店铺类型筛选（用于商品列表）
  ShopTypeFilter: [
    { label: '成盈优选', value: 1 },
    { label: '其他店铺', value: 0 },
  ],
  // 店铺流水-资金类型
  ShopWealthRecordType: [
    { label: '余额', value: 1 },
    { label: '提现冻结金额', value: 2 },
    { label: '待结算金额', value: 3 },
    { label: '总收益', value: 4 },
    { label: '已提现金额', value: 5 },
  ],
  // 店铺流水-变更途径
  ShopWealthWayType: [
    { label: '购买订单', value: 1 },
    { label: '提现申请', value: 2 },
    { label: '提现失败', value: 3 },
    { label: '提现成功', value: 4 },
    { label: '订单退款', value: 5 },
    { label: '订单完成', value: 6 },
    { label: '分门店中转站', value: 34 },
    { label: '区代中转站', value: 35 },
    { label: '市代中转站', value: 36 },
  ],
  // 支付商户开户状态
  ApplicationStatus: [
    { label: '开户完成', value: "SUCCESS" },
    { label: '开户完成', value: "COMPLETED" },
    { label: '协议待签署', value: "AGREEMENT_SIGNING" }, // 汇付
    { label: '待激活', value: "ACTIVATE_PENDING_NEW" }, // 连连
    { label: '待激活', value: "WAIT_ACTIVATE" }, // 连连
    { label: '待签署协议', value: "URL_CHECK" }, // 连连
    { label: '审核中', value: "CHECK_PENDING" }, // 连连
    { label: '审核失败', value: "AUDIT_ERROR" }, // 连连
    { label: '待开户', value: "WAIT" }, // 带开户
  ],
  // 用户角色
  UserRole: [
    { label: '普通用户', value: 1 },
    { label: '投资人', value: 2 },
  ],
  // 用户类型
  UserType: [
    { label: '普通用户', value: 0 },
    { label: 'G1', value: 1 },
    { label: '门店', value: 2 },
    { label: '区代', value: 3 },
    { label: '市代', value: 4 },
    { label: 'G5', value: 5 },
    { label: 'G6', value: 6 },
    { label: 'G7', value: 7 },
  ],
  // 战队类型
  TeamType: [
    { label: '无', value: 0 },
    { label: '作战部', value: 1 },
    { label: '百人战队', value: 2 },
  ],
  // 后台用户角色
  PlatformRole: [
    { label: '超级用户', value: 1 },
    { label: '店铺用户', value: 2 },
    { label: '平台客服1', value: 101 },
    { label: '平台客服2', value: 102 },
    { label: '平台客服3', value: 103 },
    { label: '平台客服4', value: 104 },
    { label: '平台客服5', value: 105 },
    { label: '平台财务1', value: 201 },
    { label: '技术1', value: 301 },
    { label: '前台收银', value: 401 },
  ],
   // 后台用户角色
  PlatformRoleSelect: [
    { label: '超级用户', value: 1 },
    { label: '平台客服1', value: 101 },
    { label: '平台客服2', value: 102 },
    { label: '平台客服3', value: 103 },
    { label: '平台客服4', value: 104 },
    { label: '平台客服5', value: 105 },
    { label: '平台财务1', value: 201 },
    { label: '技术1', value: 301 },
    { label: '前台收银', value: 401 },
  ],
  // 投资人数据上传状态
  InvestorIncomeFileStatus: [
    { label: '未上传', value: 0 },
    { label: '处理中', value: 1 },
    { label: '解析失败', value: 2 },
    { label: '解析成功', value: 3 },
  ],
   // 会员状态
  MemberStatus: [
    { label: '禁用', value: 0 },
    { label: '启用', value: 1 },
  ],
     // 会员状态
  MemberIsDmotion: [
    { label: '否', value: 0 },
    { label: '是', value: 1 },
  ],

      // 分红类型
  DistributionActivityType: [
    { label: '按贡献值计算', value: 1 },
    { label: '按人数计算', value: 2 },
  ],

        // 分红金额类型
  DistributionActivityNumberType: [
    { label: '固定总额', value: 1 },
    { label: '百分比', value: 2 },
  ],

    //财富类型
  WealthType: [
    { label: '贡献值', value: 1 },
    { label: '能量值', value: 2 },
    { label: '绿豆', value: 3 },
  ],


  // 途径（与后端 UserWealthWayType 一致）
  WealthWayType: [
    { label: '购买订单', value: 1 },
    { label: '下级订单分销', value: 2 },
    { label: '分红扣减', value: 3 },
    { label: '订单退款', value: 4 },
    { label: '系统充值', value: 5 },
    { label: '系统扣除', value: 6 },
    { label: '店铺推荐奖励', value: 7 },
    { label: '店铺订单', value: 8 },
    { label: '区域代理', value: 9 },
    { label: '系统恢复', value: 10 },
    { label: '省代', value: 11 },
    { label: '市代', value: 12 },
    { label: '区代', value: 13 },
    { label: '对冲', value: 14 },
    { label: '排队免单', value: 31 },
    { label: '区代奖励（已停用，历史数据）', value: 32 },
    { label: '周薪', value: 33 },
    { label: '门店核销/门店中转站', value: 34 },
    { label: '区代核销/区代中转站', value: 35 },
    { label: '市代核销/市代中转站', value: 36 },
    { label: '业绩榜门店/门店业绩奖励', value: 37 },
    { label: '业绩榜区代/区代业绩奖励', value: 38 },
    { label: '业绩榜市代/市代业绩奖励', value: 39 },
    { label: '订单分销-G2门店/门店订单分销', value: 40 },
    { label: '订单分销-G3区代/区代订单分销', value: 41 },
    { label: '订单分销-G4市代/市代订单分销', value: 42 },
    { label: '门店平级奖励/门店推荐奖励', value: 43 },
    { label: '区代平级奖励/区代推荐奖励', value: 44 },
    { label: '市代平级奖励/市代推荐奖励', value: 45 },
    { label: '订单分销-G1会员推荐/订单分销-G1', value: 46 },
    { label: '订单分销-G5', value: 47 },
    { label: '订单分销-G6', value: 48 },
    { label: '订单分销-G7', value: 49 },
    { label: 'G5平级奖励（绿豆）/订单金额区间奖励能量值（能量）', value: 50 },
    { label: 'G6平级奖励', value: 51 },
    { label: 'G7平级奖励', value: 52 },
    { label: '能量值奖励', value: 56 },
    { label: '排队补贴', value: 57 },
    { label: '订单分销-会员（九档一档直发）', value: 58 },
    { label: '订单分销-会员平级', value: 59 },
    { label: '订单分销-VIP（二档直发）', value: 60 },
    { label: '订单分销-VIP平级', value: 61 },
    { label: '订单分销-G1平级（主分配仍为46）', value: 62 },
    { label: '分红池发放-市代池', value: 63 },
    { label: '分红池发放-区代池', value: 64 },
    { label: '分红池发放-门店池', value: 65 },
    { label: '分红池发放-作战池', value: 66 },
    { label: '分红池发放-营销池', value: 67 },
    { label: '分红池发放-车奖池', value: 68 },
    { label: '分红池发放-市场池', value: 69 },
    { label: '分红池发放-预留池', value: 70 },
    { label: '分销绿豆（订单分销部分，详见备注）', value: 71 },
    { label: '广告奖励', value: 76 },
    { label: '签到奖励', value: 77 },
    { label: '日活跃度排行奖励', value: 78 },
    { label: '区代推荐奖励', value: 79 },
    { label: '特价商品补贴', value: 80 },
    { label: '复购补贴', value: 82 },
    { label: '活跃度兑换贡献值', value: 83 },
    { label: '特殊关单退绿豆', value: 84 },
    { label: '特殊关单冲销分佣', value: 85 },
    { label: '特殊关单回滚', value: 86 },
  ],

  WealthStatus: [
    { label: '待入账', value: 0 },
    { label: '已完成', value: 1 },
    { label: '已退款', value: 2 },
    { label: '已退款', value: 3 },
  ],

  /** 分配型绿豆充值-分配段类型 */
  MungBeanAllocateSegmentType: [
    { label: '直推有身份', value: 'DIRECT_IDENTITY' },
    { label: '直推无身份本人', value: 'DIRECT_NON_IDENTITY' },
    { label: '最近身份上级', value: 'DIRECT_NEAREST_IDENTITY' },
    { label: '十代', value: 'TEN_GEN' },
  ],
  /** 分配型绿豆充值-沉淀原因 */
  MungBeanAllocateSedimentReason: [
    { label: '无直推，直推池全额沉淀', value: 'NO_DIRECT_REFERRER' },
    { label: '直推无身份且向上无门店/区代/市代', value: 'NO_IDENTITY_UP_FROM_DIRECT' },
    { label: '该代无身份用户', value: 'TEN_GEN_SLOT_EMPTY' },
    { label: '十代比例计算舍入残差', value: 'ROUNDING_RESIDUAL' },
  ],

  //银行卡卡类型
  BankType: [
    { label: '借记卡', value: 0 },
    { label: '对公卡', value: 1 },
  ],
  //银行卡类别
  BankAccountType: [
    { label: '店铺', value: 2 },
  ],
  //银行卡用途
  SourceType: [
    { label: '提现卡', value: 0 },
    { label: '认证卡（也可提现）', value: 1 },
  ],
  //易宝入网处理状态
  RegistMerchantStatus: [
    { label: '申请审核中', value: 'REVIEWING' },
    { label: '申请已驳回', value: 'REVIEW_BACK' },
    { label: '真实性验证中', value: 'AUTHENTICITY_VERIFYING' },
    { label: '协议待签署', value: 'AGREEMENT_SIGNING' },
    { label: '业务开通中', value: 'BUSINESS_OPENING' },
    { label: '申请已完成', value: 'COMPLETED' },
  ],
  //配送方式
  DeliveryType: [
    { label: '快递', value: 0 },
    { label: '自提', value: 1 },
  ],
  //有效期类型
  ValidityType: [
    { label: '非长期有效', value: "0" },
    { label: '长期有效', value: "1" },
  ],
  //有效期类型
  PlatformWealthRecordType: [
    { label: '订单', value: 1 },
    { label: '补贴', value: 2 },
    { label: '手动增加', value: 3 },
    { label: '手动减少', value: 4 },
  ],
  // 汇付账户类型
  HuifuAcctType: [
    { label: '基本户', value: '01' },
    { label: '现金户', value: '02' },
    { label: '延时户', value: '03' },
    { label: '钱包户', value: '04' },
    { label: '充值户', value: '05' },
    { label: '营销户', value: '09' },
    // 连连
    { label: '可用账户', value: 'USEROWN_AVAILABLE' },
    { label: '结算账户', value: 'USEROWN_PSETTLE' },

  ],
  // 汇付账户状态
  HuifuAcctStat: [
    { label: '正常', value: 'N' },
    { label: '关闭', value: 'C' },
    { label: '冻结', value: 'F' },
    { label: '销户', value: 'D' },
  ],
     // 区域代理级别
  MemberAddressConfigLevel: [
    { label: '省代', value: 1 },
    { label: '市代', value: 2 },
    { label: '区代', value: 3 },

  ],
  // 区域代理级别
  PayChannelMerchant: [
    { label: '汇付支付', value: "huifu" },
    { label: '连连支付', value: "llpay" },

  ],
  // 区域代理级别
  PayChannelMerchant2: [
    { label: '汇付', value: "汇付" },
    { label: '连连', value: "连连" },
    { label: '绿豆', value: "绿豆" },

  ],

  // 操作日志-操作类型
  OperLogBusinessType: [
    { label: '其它', value: 0 , tagType:"info"},
    { label: '新增', value: 1 , tagType:"info"},
    { label: '修改', value: 2 , tagType:"info"},
    { label: '删除', value: 3 , tagType:"danger"},
    { label: '授权', value: 4 , tagType:"primary"},
    { label: '导出', value: 5 , tagType:"warning"},
    { label: '导入', value: 6 , tagType:"warning"},
    { label: '强退', value: 7 , tagType:"danger"},
    { label: '生成代码', value: 8 , tagType:"warning"},
    { label: '清空数据', value: 9 , tagType:"danger"},
    { label: '查询', value: 10 , tagType:"info"},
  ],
  // 操作日志-状态
  OperLogStatus: [
    { label: '正常', value: 0, tagType:"primary" },
    { label: '异常', value: 1, tagType:"danger" },
  ],
   OrderAllocateErrorType: [
    { label: '支付完成', value: 0},
    { label: '订单完成', value: 1},
    { label: '订单退款', value: 2},
  ],
   OrderAllocateErrorStatus: [
    { label: '尚未成功', value: 0 , tagType:"danger"},
    { label: '执行成功', value: 1 , tagType:"success"},
  ],
}
export default constan
